import { createTheme } from '@mui/material/styles';

export const shades = {
  // red
  primary: {
    100: '#ffcccc',
    200: '#ff9999',
    300: '#ff6666',
    400: '#ff3333',
    500: '#ff0000',
    600: '#cc0000',
    700: '#990000',
    800: '#660000',
    900: '#330000'
  },
  // black
  secondary: {
    100: '#cccccc',
    200: '#999999',
    300: '#666666',
    400: '#333333',
    500: '#000000',
    600: '#000000',
    700: '#000000',
    800: '#000000',
    900: '#000000'
  },
  // gray
  neutral: {
    100: '#eeeeee',
    200: '#dddddd',
    300: '#cbcbcb',
    400: '#bababa',
    500: '#a9a9a9',
    600: '#878787',
    700: '#656565',
    800: '#444444',
    900: '#222222'
  },
  // white
  white: {
    100: '#ffffff',
    200: '#ffffff',
    300: '#ffffff',
    400: '#ffffff',
    500: '#ffffff',
    600: '#cccccc',
    700: '#999999',
    800: '#666666',
    900: '#fbf0f0'
  },
  // teal
  accent: {
    100: '#ccf2f4',
    200: '#99e5e9',
    300: '#66d7df',
    400: '#33cad4',
    500: '#00bdc9',
    600: '#0097a1',
    700: '#007179',
    800: '#004c50',
    900: '#002628'
  }
};

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: shades.primary[500]
    },
    secondary: {
      main: shades.secondary[500]
    },
    background: {
      default: shades.secondary[500],
      paper: shades.neutral[800]
    },
    text: {
      primary: shades.white[100],
      secondary: shades.white[300]
    },
    // palette properties
    action: {
      active: shades.white[100],
      hover: 'rgba(255, 255, 255, 0.08)',
      selected: 'rgba(255, 255, 255, 0.16)',
      disabled: 'rgba(255, 255, 255, 0.3)',
      disabledBackground: 'rgba(255, 255, 255, 0.12)'
    },
    divider: 'rgba(255, 255, 255, 0.12)'
  },
  typography: {
    fontFamily: ['Didact Gothic', 'sans-serif'].join(','),
    fontSize: 14,
    fontWeight: 400,
    h1: {
      fontFamily: ['Cardo', 'serif'].join(','),
      fontSize: 48,
      fontWeight: 400
    },
    h2: {
      fontFamily: ['Cardo', 'serif'].join(','),
      fontSize: 36,
      fontWeight: 400
    },
    h3: {
      fontFamily: ['Cardo', 'serif'].join(','),
      fontSize: 20,
      fontWeight: 400
    },
    h4: {
      fontFamily: ['Cardo', 'serif'].join(','),
      fontSize: 16,
      fontWeight: 400
    }
  }
});
